import { render } from "./Taping.vue?vue&type=template&id=4e2c6582&scoped=true"
import script from "./Taping.vue?vue&type=script&lang=js"
export * from "./Taping.vue?vue&type=script&lang=js"

import "./Taping.vue?vue&type=style&index=0&id=4e2c6582&scoped=true&lang=css"

import exportComponent from "/home/angelkiro/Dev/SVPhysio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2c6582"]])

export default __exports__